import { render, staticRenderFns } from "./RoleProfileCard.vue?vue&type=template&id=4f87d132"
import script from "./RoleProfileCard.vue?vue&type=script&lang=js"
export * from "./RoleProfileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports